import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, loading } from '../../actions';
import { getData } from '../../dataLib';
import { setCentroDia } from '../../actions/centro_dia_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    formControl:{
        marginLeft: '10px'
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeArticulo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            centroId: this.props.centroDiaSelected.dia !== '' ? this.props.centroDiaSelected.centro.id : 1,
            articulos: [],
        }

    };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.getArticulos(this.state.centroId ? this.state.centroId : -1);

    };

    getArticulos = (centro_id) => {

        this.props.loading(true);
        getData(
            'ArticuloCompraCtl/list/' + centro_id,
            (response) => {
                this.props.loading(false);
                this.setState({ ...this.state, articulos: response.data })
            },
            () => {
                this.props.loading(false);
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching ArticuloCompraCtl'
                }, uuidv4(), false, 'sm');
            },
            this.props.user
        );
    };


    editArticulo = (articulo) => {
        this.props.navigate("edit_articulo/" + articulo.idArticuloCompraCentro);
    };

    handleSelectCentrosValueChange = (event) => {
        const c_id = parseInt(event.target.value ? event.target.value : 1);
        this.setState({ ...this.state, centroId: c_id },
            () => {
                this.getArticulos(c_id);
                this.props.setCentroDia(c_id, this.props.centroDiaSelected.dia, false);
            });
    };

    renderSelectCentros = () => {

        if (this.props.kd !== undefined) return('');
        
        const perfil = this.props.userProfile.selectedCentroProfile?this.props.userProfile.selectedCentroProfile.iPerfil:0;

        const centros = [0, 4, 5, 17, 20].includes(perfil) ?
            this.props.centros.filter(c => c.activo === 1)
            : this.props.centros.filter(c => c.id === this.props.userProfile.selectedCentroProfile.centroId);

        const { classes } = this.props;
        return (
            <FormControl className={classes.formControl}>
                <InputLabel htmlFor="input-centros">Centro</InputLabel>
                <Select className={classes.centroSelect}
                    native
                    value={this.state.centroId}
                    onChange={(event) => this.handleSelectCentrosValueChange(event)}
                    input={<Input id="input-centros" />}
                    name="centroId"
                >
                    {centros.map(centro => {
                        return (<option key={'centro_' + centro.id} value={centro.id}>{centro.centro}</option>)
                    })}
                </Select>
            </FormControl>
        );
    };

    render() {

        const { classes } = this.props;

        return (

            <div className={classes.root}>
                <div className={classes.toolbar} />

                {this.renderSelectCentros()}

                    <NeuriteGrid
                        id="m_r_a"
                        columns={[
                            { key: 'descr', name: 'Nombre', editable: false, dragable: false, width: 250 },
                            { key: 'stock', name: 'Stock', editable: false, dragable: false, width: 60, type: 'int' },
                            { key: 'familia', name: 'Subfamilia', editable: false, dragable: false, width: 100 },
                            { key: 'subfamilia', name: 'Subfamilia', editable: false, dragable: false, width: 100 },
                            { key: 'codBarras', name: 'Cod. Barras', editable: false, dragable: false, width: 120 },
                            { key: 'cod', name: 'Cod. CC', editable: false, dragable: false, width: 60 },
                            { key: 'ultPuntos', name: 'Puntos', type: 'int', editable: false, dragable: false, width: 60 },
                            { key: 'ultPrecio', name: 'Precio', type: 'float', editable: false, dragable: false, width: 60 },
                            { key: 'hasFoto', name: 'Foto?', editable: false, dragable: false, width: 55, type: 'bool' },
                            { key: 'activo', name: 'Activo?', editable: false, dragable: false, width: 55, type: 'bool' },
                        ]}
                        rows={this.state.articulos}
                        buttonEdit={true}
                        buttonDelete={false}
                        buttonNew={false}
                        height={500}
                        onEditClick={this.editArticulo}
                        enableFilter={true}
                    />
            </div>
        );

    };

};

MaeArticulo.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centros: PropTypes.array.isRequired,
    centroId: PropTypes.number.isRequired,

    //dispatch
    navigate: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        userProfile: state.userProfile,
        centros: state.centros.centros,
        centroDiaSelected: state.centroDiaSelected,
        kd: state.userProfile.kd,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        openDialog,
        setCentroDia,
        loading
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeArticulo));
